import { useLang } from "../../context/LanguageContext";
import { ShieldCheck, Mail, MessageCircle, Calendar, Sparkles } from "lucide-react";

export default function TrustBar() {
  const { lang } = useLang();
  const items = lang === "de"
    ? [
        { icon: ShieldCheck,    label: "Sichere Zahlung",   sub: "Stripe · 256-bit SSL" },
        { icon: Mail,           label: "Sofort-Bestätigung", sub: "Per E-Mail in < 2 Min" },
        { icon: Calendar,       label: "Flexible Stornierung", sub: "Bis 14 Tage vor Anreise" },
        { icon: MessageCircle,  label: "WhatsApp-Support",    sub: "+43 664 1004293" },
        { icon: Sparkles,       label: "Authentisch alpin",   sub: "Familiengeführt seit 2008" },
      ]
    : [
        { icon: ShieldCheck,    label: "Secure payment",     sub: "Stripe · 256-bit SSL" },
        { icon: Mail,           label: "Instant confirmation", sub: "By email in < 2 min" },
        { icon: Calendar,       label: "Flexible cancellation", sub: "Up to 14 days before arrival" },
        { icon: MessageCircle,  label: "WhatsApp support",    sub: "+43 664 1004293" },
        { icon: Sparkles,       label: "Authentic alpine",     sub: "Family-run since 2008" },
      ];

  return (
    <section data-testid="trust-bar" className="relative bg-[hsl(var(--muted))] border-y border-[hsl(var(--border))]">
      <div className="container-x py-7">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-x-8 md:gap-x-10 gap-y-7">
          {items.map(({ icon: Icon, label, sub }, i) => (
            <div key={i} data-testid={`trust-item-${i}`} className="flex items-center gap-3.5">
              <div className="shrink-0 inline-flex items-center justify-center w-10 h-10 border border-[hsl(var(--accent))]/40 bg-[hsl(var(--accent))]/10 text-[hsl(var(--accent))]">
                <Icon className="w-[18px] h-[18px]" strokeWidth={1.75} />
              </div>
              <div className="min-w-0">
                <div className="text-[12px] tracking-[0.04em] font-semibold text-[hsl(var(--foreground))] truncate">{label}</div>
                <div className="text-[10px] tracking-[0.18em] uppercase text-[hsl(var(--foreground))]/88 truncate mt-0.5">{sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
